import { ClientAuth } from '@/classes';
import { useRouter } from '@/hooks/useRouter';
import { ContentGroupDetail } from '@/widgets/content-group-detail';
import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';

export const TopicDetailPage = () => {
  const router = useRouter();
  const { id } = useParams();

  useEffect(() => {
    if (!ClientAuth.user) {
      router.push('/login', { replace: true });
    }
  }, [router]);

  const contentGroupId = useMemo(() => {
    if (id && !isNaN(Number(id))) {
      return Number(id);
    }

    return null;
  }, [id]);

  return (
    <div className="flex flex-col lg:flex-row h-screen overflow-hidden">
      {contentGroupId && <ContentGroupDetail id={contentGroupId} sourcePage="topic" />}
    </div>
  );
};
